export default function createProfileWithOutService({ next, store }) {
  console.log("store.getters.getProfileUserType=>", store.getters["auth/getProfileUserType"]);
  const status = store.getters["auth/getProfileUserType"];
  if (
    status === "advisor" ||
    status === "investor" ||
    status === "company" ||
    status == "freelancer"
  ) {
    return next();
  }
  return next({ name: "misc-not-authorized" });
}
